import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import Button from "../../../components/button";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import API from "../../../api";
import { mapDispatchProps, mapStateToProps } from "../../../store/store";
import { connect } from "react-redux";
import { useLanguage } from '@languages/index';

interface Props {
  className?: string;
  onClick?: any;

  style?: any;

  image?: any;
  index?: any;
  url?: any;

  auth?: any;
  onUpdate?: any;
  showModal?: any;
  closeModal?: any;
}

const ImageCropper = (props: Props) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.pages.sns };
  let className = clsx("sns-posting-cropper", `${props.className}`);

  const cropperRef = useRef(null);
  const [inputImage, setInputImage] = useState(null);
  const croppedImage = useRef(null);

  useEffect(() => {
    if (props.url && inputImage !== props.url) {
      setInputImage(props.url);
    }
  }, [props.url]);

  const cropImage = async () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;

    if (props.image.id) {
      cropper.getCroppedCanvas().toBlob(
        (blob) => {
          API.Post.cropImage({
            brandToken: props.auth.token,
            imageId: props.image.id,
            image: blob,
          })
            .then((response) => {
              props.onUpdate
                ? props.onUpdate(props.image, props.index, response)
                : null;
              props.showModal({ text: response.message });
            })
            .catch((error) => {
              props.showModal({ text: error.message });
            })
            .finally(() => {});
        },
        "image/jpeg",
        0.95
      );
    } else {
      const img = await cropper.getCroppedCanvas().toDataURL();
      const blob = cropper.getCroppedCanvas().toBlob(
        (blob) => {
          API.Post.uploadImage({
            brandToken: props.auth.token,
            image: blob,
          })
            .then(async (response) => {
              props.onUpdate
                ? props.onUpdate(
                    { ...props.image, ...{ thumbSmUrl: img } },
                    props.index,
                    {
                      data: {
                        url: `https://nmodelin20.s3.ap-northeast-2.amazonaws.com/posting/thumb-sm/${response.data.url}`,
                      },
                    }
                  )
                : null;
              props.showModal({ text: response.message });
            })
            .catch((error) => {
              props.showModal({ text: error.message });
            })
            .finally(() => {});
        },
        "image/jpeg",
        0.95
      );
    }
  };

  return (
    <div className={className} style={props.style ? props.style : {}}>
      <div className="flex flex-col h-[85dvh] my-auto mx-auto">
        <div className="flex flex-row w-full h-full">
          <div className="aspect-[0.7825]">
            <Cropper
              className="w-full h-full"
              src={inputImage}
              ref={cropperRef}
              initialAspectRatio={0.7825}
              aspectRatio={0.7825}
            />
          </div>
        </div>

        <div className="flex flex-row">
          <Button
            buttonColor={"WHITE"}
            text={languageTexts.close}
            textColor={"BLACK"}
            onClick={() => {
              props.closeModal();
            }}
          />
          <Button
            buttonColor={"BLACK"}
            text={languageTexts.confirm}
            textColor={"WHITE"}
            onClick={() => {
              cropImage();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchProps)(ImageCropper);
